import { useEffect } from 'react';
import { Button } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
interface ErrorBoundaryFallbackProps {
  error?: Error;
}
export const ErrorBoundaryFallback = ({
  error
}: ErrorBoundaryFallbackProps) => {
  const {
    t
  } = useTranslation(['auth']);
  useEffect(() => {
    if (error) {
      // 대시보드 호환: error_captured(auto)와 별도로 user-facing boundary 도달을 표시
      logger.debug('enter_error_boundary', {
        errorName: error.name,
        errorMessage: error.message
      });
      logger.captureError(error, {
        tags: {
          source: 'ErrorBoundaryFallback',
          globalErrorBoundaryRendered: true
        }
      });
    }
  }, [error]);
  return <div className="fixed left-1/2 top-1/2 flex w-full -translate-x-1/2 -translate-y-1/2 flex-col items-center gap-4" data-sentry-component="ErrorBoundaryFallback" data-sentry-source-file="ErrorBoundaryFallback.tsx">
      <ErrorIcon data-sentry-element="ErrorIcon" data-sentry-source-file="ErrorBoundaryFallback.tsx" />
      <span className="text-xl font-extrabold text-[#27262E]">
        {t('auth:error.loadFailed')}
      </span>
      <span className="text-center text-sm font-medium text-[#6B7280]">
        {t('auth:error.retryLater')}
      </span>
      <Button type="button" variant="contained" intent="strong" size="md" className="mt-2" onClick={() => window.location.reload()} data-sentry-element="Button" data-sentry-source-file="ErrorBoundaryFallback.tsx">
        {t('auth:error.refresh')}
      </Button>
    </div>;
};
const ErrorIcon = () => <svg width={48} height={48} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="에러 아이콘" data-sentry-element="svg" data-sentry-component="ErrorIcon" data-sentry-source-file="ErrorBoundaryFallback.tsx">
    <path d="M12 9V13M12 17H12.01M10.29 3.86L1.82 18C1.64 18.3 1.55 18.64 1.55 19C1.55 19.36 1.64 19.7 1.82 20C2 20.3 2.26 20.56 2.56 20.74C2.86 20.92 3.21 21.01 3.56 21H20.44C20.79 21.01 21.14 20.92 21.44 20.74C21.74 20.56 22 20.3 22.18 20C22.36 19.7 22.45 19.36 22.45 19C22.45 18.64 22.36 18.3 22.18 18L13.71 3.86C13.53 3.56 13.27 3.32 12.97 3.15C12.67 2.98 12.34 2.89 12 2.89C11.66 2.89 11.33 2.98 11.03 3.15C10.73 3.32 10.47 3.56 10.29 3.86Z" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="ErrorBoundaryFallback.tsx" />
  </svg>;